import React, { useState } from 'react';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faQuestion, faTowerBroadcast, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { exit_stream } from '../script';

const Layout = (props) => {
  const [isNavExpanded, setIsNavExpanded] = useState(false); // State for controlling navbar collapse
  const navigate = useNavigate();
  const path = useLocation().pathname;

  const handleNavLinkClick = (destination) => {
    setIsNavExpanded(false); // Collapse the menu
    navigate(destination);  // Navigate to the destination
  };

  return (
    <>
      <div style={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        fontFamily: "Arial, sans-serif"
      }}>
        <Navbar expand="lg" className="bg-body-tertiary navbar-fixed" expanded={isNavExpanded}>
          <Navbar.Brand href="/">
            <img src="/6hats.png" alt="Logo" width="150" />
          </Navbar.Brand>
          <Navbar.Toggle
            aria-controls="basic-navbar-nav"
            onClick={() => setIsNavExpanded(!isNavExpanded)} // Toggle navbar state
          />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link onClick={() => handleNavLinkClick("/about")}>About</Nav.Link>
              <Nav.Link onClick={() => handleNavLinkClick("/terms")}>Terms</Nav.Link>
              <Nav.Link onClick={() => handleNavLinkClick("/privacy")}>Privacy</Nav.Link>
              <Nav.Link onClick={() => handleNavLinkClick("/account")}>
                {props.loggedInEmail ? "Account" : "Login"}
              </Nav.Link>
              {
                props.loggedInEmail && (
                  <Nav.Link
                    id="btn-logout"
                    className="navbar-right"
                    onClick={() => {
                      if (window.confirm("Are you sure you want to logout?")) {
                        localStorage.removeItem("useremail");
                        props.setLoggedInEmail(undefined);
                        window.location.href = "/";
                      }
                    }}
                  >
                    <img src="/icons/logout.svg" style={{ height: "20px" }} />
                  </Nav.Link>
                )
              }
            </Nav>
          </Navbar.Collapse>
          {
            path === "/" && (
              <Nav.Link id="btn-new-stream" className="navbar-right">
                <FontAwesomeIcon icon={faPlus} />
              </Nav.Link>
            )
          }
          {
            (localStorage.getItem("useremail")) && (
              <Nav.Link
                id="btn-view-stream"
                className="navbar-right"
                style={{ margin: "5px" }}
                onClick={() => {
                  navigate("/streams");
                }}
              >
                <FontAwesomeIcon icon={faTowerBroadcast} />
              </Nav.Link>
            )
          }
          <Nav.Link
            id="btn-search"
            className="navbar-right"
            style={{ margin: "5px" }}
            onClick={() => {
              handleNavLinkClick("/search");
            }}
          >
            <FontAwesomeIcon icon={faMagnifyingGlass} />
          </Nav.Link>
        </Navbar>
        <Outlet />
      </div>
    </>
  );
};

export default Layout;
